import { webDtos } from '@vectronic/openApi-customer';

export const POSITIONS: webDtos.GPSPosition[] = [
  {
    idData: 111111,
    idDevice: 3,
    acquisitionTime: new Date(2017, 4, 4, 17, 23, 42, 11).toISOString(),
    scts: new Date(2017, 4, 4, 17, 23, 42, 12).toISOString(),
    originCode: 'IRIDIUM',
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111112,
    idDevice: 3,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any, //TODO .toISOString() and done?
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any, //TODO .toISOString() and done?

    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111113,
    idDevice: 3,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any, //TODO .toISOString() and done?
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any, //TODO .toISOString() and done?
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111113,
    idDevice: 3,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any,
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any,
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111114,
    idDevice: 3,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any,
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any,
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111115,
    idDevice: 3,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any,
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any,
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111120,
    idDevice: 3,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any,
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any,
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111121,
    idDevice: 4,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any,
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any,
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
  {
    idData: 111122,
    idDevice: 4,
    acquisitionTime: new Date(2017, 4, 5, 17, 23, 42, 11) as any,
    scts: new Date(2017, 4, 5, 17, 23, 42, 12) as any,
    ecefX: 4212854,
    ecefY: 3112854,
    ecefZ: 3212854,
    latitude: 29.6105973914479,
    longitude: 35.3687010672854,
    altitude: 939,
    dop: 16,
    positionError: undefined,
    satCount: 0,
    ch01SatId: undefined,
    ch01SatCnr: undefined,
    ch02SatId: undefined,
    ch02SatCnr: undefined,
    ch03SatId: undefined,
    ch03SatCnr: undefined,
    ch04SatId: undefined,
    ch04SatCnr: undefined,
    ch05SatId: undefined,
    ch05SatCnr: undefined,
    ch06SatId: undefined,
    ch06SatCnr: undefined,
    ch07SatId: undefined,
    ch07SatCnr: undefined,
    ch08SatId: undefined,
    ch08SatCnr: undefined,
    ch09SatId: undefined,
    ch09SatCnr: undefined,
    ch10SatId: undefined,
    ch10SatCnr: undefined,
    ch11SatId: undefined,
    ch11SatCnr: undefined,
    ch12SatId: undefined,
    ch12SatCnr: undefined,
    activity: undefined,
    mainVoltage: 3.36,
    backupVoltage: 3.6,
    temperature: 30,
    lightCondition: 'DARK',
    utmEasting: 500000.0,
    utmNorthing: 4000000.0,
    utmZone: 32,
    utmLetter: 'U',
  },
];
